// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8d73ebd9","270":"7d435519","285":"8a4e5ffc","415":"3da69ba6","910":"f529415b"}[chunkId] + ".chunk.js";
};